import { CollectError } from '../config';

export function validateIcons(value: Record<string, string>): void {
  Object.values(value).forEach((icon) => {
    if (icon) {
      try {
        const { protocol } = new URL(icon);
        if (protocol !== 'data:') {
          throw new Error();
        }
      } catch (e) {
        throw new CollectError('The icon URL can be only a Data URL with base64 encoded image');
      }
    }
  });
}
